"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "admin-home" };
const _hoisted_2 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("ul", null, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.paths, (path) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", { key: path }, [
                    (0, vue_1.createElementVNode)("a", {
                        href: path + '?serverId=' + _ctx.serverId
                    }, (0, vue_1.toDisplayString)(path), 9, _hoisted_2)
                ]));
            }), 128))
        ])
    ]));
}
